export default "__VITE_ASSET__CAd3NCL0__"